import { c as _c } from "react/compiler-runtime";
import { useRef } from 'react';
export const useTimer = () => {
  const $ = _c(2);
  const prevTimeRef = useRef(undefined);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = Date.now();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const currentTimeRef = useRef(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    const check = () => {
      const newTime = Date.now();
      const difference = prevTimeRef.current ? newTime - currentTimeRef.current : undefined;
      prevTimeRef.current = currentTimeRef.current;
      currentTimeRef.current = newTime;
      return difference;
    };
    t1 = {
      check
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};